import styled, { css } from 'styled-components';
import Button from '../Button';
import Link from '../Link';
import { InfoCardsWrapper } from '../ApartPage/styles';

const getGridTemplate = (
	withRelevance,
	withStat,
	withMortgage,
	withAdvert,
	withAllFlats,
	withAvgPrice,
	withRelated,
	screen,
) => {
	switch (screen) {
		case 'desktop':
			return css`'title price'
			'slider price'
			'props props'
			${withAdvert && `'apartAdvert apartAdvert'`}
			${withStat && `'descriptionStats descriptionStats'`}
			${withMortgage && `'mortgage mortgage'`}
			'map map'
			'house house'
			${withRelevance && `'relevance relevance'`}
			${withAllFlats && `'allflats allflats'`}
			${withAvgPrice && `'avgprice avgprice'`}
			'lastViewedAndSimilar lastViewedAndSimilar'
			`;
		case 'tablet':
			return css`'title title'
			'slider slider'
			'price props'
			'price .'
			${withAdvert && `'apartAdvert apartAdvert'`}
			${withStat && `'descriptionStats descriptionStats'`}
			${withMortgage && `'mortgage mortgage'`}
			'map map'
			'house house'
			${withRelevance && `'relevance relevance'`}
			${withAllFlats && `'allflats allflats'`}
			${withAvgPrice && `'avgprice avgprice'`}
			'lastViewedAndSimilar lastViewedAndSimilar'`;
		case 'mobile':
			return css`
			'slider'
			'title'
			'price'
			'props'
			${withAdvert && `'apartAdvert'`}
			${withStat && `'descriptionStats'`}
			${withMortgage && `'mortgage'`}
			'map'
			'house'
			${withRelevance && `'relevance'`}
			${withAllFlats && `'allflats'`}
			${withAvgPrice && `'avgprice'`}
			'lastViewedAndSimilar'`;
		default:
			return css`'title price'
		'slider price'
		'props price'
		${withAdvert && `'apartAdvert price'`}
		${withStat && `'descriptionStats price'`}
		${withMortgage && `'mortgage price'`}
		'map price'
		'house price'
		${withRelevance && `'relevance price'`}
		${withAllFlats && `'allflats price'`}
		${withAvgPrice && `'avgprice price'`}
			'lastViewedAndSimilar lastViewedAndSimilar'`;
	}
};

export const MainGrid = styled.div`
	position: relative;
	margin-top: 24px;
	background-color: transparent;
	display: grid;
	grid-template-columns: 70% 1fr;
	grid-template-areas: ${({
		$withRelevance,
		$withStat,
		$withMortgage,
		$withAdvert,
		$withAllFlats,
		$withAvgPrice,
		$withRelated,
	}) =>
		getGridTemplate(
			$withRelevance,
			$withStat,
			$withMortgage,
			$withAdvert,
			$withAllFlats,
			$withAvgPrice,
			$withRelated,
		)};
	grid-gap: 24px;

	@media (max-width: 1280px) {
		grid-template-columns: 60% 1fr;
	}

	@media (max-width: 1025px) {
		grid-template-columns: 55% 1fr;
		grid-template-areas: ${({
			$withRelevance,
			$withStat,
			$withMortgage,
			$withAdvert,
			$withAllFlats,
			$withAvgPrice,
			$withRelated,
		}) =>
			getGridTemplate(
				$withRelevance,
				$withStat,
				$withMortgage,
				$withAdvert,
				$withAllFlats,
				$withAvgPrice,
				$withRelated,
				'desktop',
			)};
	}

	@media (max-width: 769px) {
		grid-template-columns: 1fr 1fr;
		grid-template-areas: ${({
			$withRelevance,
			$withStat,
			$withMortgage,
			$withAdvert,
			$withAllFlats,
			$withAvgPrice,
			$withRelated,
		}) =>
			getGridTemplate(
				$withRelevance,
				$withStat,
				$withMortgage,
				$withAdvert,
				$withAllFlats,
				$withAvgPrice,
				$withRelated,
				'tablet',
			)};
	}

	@media (max-width: 640px) {
		margin-top: 0;
		grid-gap: 16px;
		grid-template-columns: 100%;
		grid-template-areas: ${({
			$withRelevance,
			$withStat,
			$withMortgage,
			$withAdvert,
			$withAllFlats,
			$withAvgPrice,
			$withRelated,
		}) =>
			getGridTemplate(
				$withRelevance,
				$withStat,
				$withMortgage,
				$withAdvert,
				$withAllFlats,
				$withAvgPrice,
				$withRelated,
				'mobile',
			)};
	}
`;

export const SidebarWrapper = styled.div`
	grid-area: price;
	position: relative;
`;

export const LinkButton = styled(Button)`
	display: inline-flex;
	padding: 0;
	background-color: transparent;
	border: none;
	color: ${({ theme }) => theme.primaryColor};
	text-decoration: underline;
	font-size: ${({ isBig }) => (isBig ? '14px' : '12px')};

	&:hover {
		background-color: transparent;
		border: none;
		color: ${({ theme }) => theme.primaryColor};
		text-decoration: none;
	}

	&:focus {
		border: none;
	}
`;

export const PropsWrapper = styled(InfoCardsWrapper)`
	grid-area: ${({ $isBuilding }) => ($isBuilding ? `house` : `props`)};
`;

export const Props = styled.div`
	margin: 0;
	padding: 14px 26px;
	box-shadow: 0 0 8px rgba(0, 0, 0, 0.08);
	border-radius: 5px;
`;

export const MapBlock = styled.div`
	position: relative;
	width: 100%;
	height: 500px;

	@media (max-width: 768px) {
		height: 30vh;
	}

	@media (max-width: 480px) {
		height: 50vh;
	}
`;

export const AllFlatsWrapper = styled.div`
	grid-area: allflats;
	margin: 60px 0 0;
`;

export const TabsWrapper = styled.div`
	display: flex;
	width: 100%;

	${({ $isMobile }) =>
		$isMobile &&
		`
		border: 1px solid #e0e0e0;
		border-radius: 5px;
		overflow: hidden;
	`}
`;

export const TabsTitle = styled.p`
	font-size: 14px;
	line-height: 1.33;
	font-weight: 600;
	color: #333;
	margin: 0 0 6px 0;
`;

export const Tab = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 32px;
	flex: 1 1 100%;
	box-shadow: none;
	background: ${({ theme, $isActive, $isMobile }) => ($isMobile && $isActive ? theme.primaryColor : 'transparent')};
	font-size: 14px;
	text-align: center;
	color: ${({ theme, $isActive, $isMobile }) => ($isActive ? ($isMobile ? '#fff' : theme.primaryColor) : '#333')};
	border: none;
	border-bottom: ${({ theme, $isActive, $isMobile }) =>
		!$isMobile ? ($isActive ? `4px solid ${theme.primaryColor}` : '4px solid #fff') : 'none'};
	cursor: pointer;

	&:not(:last-of-type) {
		border-right: ${({ theme, $isActive, $isMobile }) =>
			$isMobile ? ($isActive ? `1px solid ${theme.primaryColor}` : '1px solid #e0e0e0') : 'none'};
	}
`;

export const MobileSortingWrapper = styled.div`
	margin: 20px 0 35px;
`;

export const AllFlatsTable = styled.div`
	display: flex;
	flex-direction: column;
	box-shadow: 0 0 8px rgba(0, 0, 0, 0.08);
	border-radius: 5px;

	@media (max-width: 600px) {
		box-shadow: none;
		border-radius: 0;
	}
`;

export const AllFlatsTableHead = styled.div`
	display: grid;
	grid-template-columns: 105px repeat(3, 1fr) 16px;
	grid-column-gap: 30px;
	padding: 12px 26px;
	color: #999;
	font-size: 14px;
	line-height: 1.43;

	@media (max-width: 600px) {
		display: none;
	}
`;

export const AllFlatsTableHeadButton = styled.button`
	display: flex;
	align-items: center;
	padding: 0;
	background-color: transparent;
	border: none;
	box-shadow: none;
	color: currentColor;
	cursor: pointer;
	transition: color 0.2s;

	&:hover {
		color: #333;
	}

	svg {
		display: block;
		width: 16px;
		height: 16px;
		margin-right: 8px;
		flex-shrink: 0;
		fill: currentColor;
	}
`;

export const AllFlatsTableRow = styled.div`
	display: grid;
	grid-template-areas: 'photo area floor price like';
	grid-template-columns: 105px repeat(3, 1fr) 18px;
	grid-column-gap: 30px;
	align-items: center;
	padding: 12px 26px;
	border-top: 1px solid #ebebeb;

	@media (max-width: 600px) {
		margin: 5px 0;
		padding: 10px 20px 10px 10px;
		border: 1px solid #ebebeb;
		border-radius: 5px;
		align-items: start;
		grid-column-gap: 15px;
		grid-template-areas: 'photo area like' 'photo price like' 'photo floor like';
		grid-template-columns: 110px 1fr 18px;
	}

	@media (max-width: 480px) {
		grid-template-columns: 70px 1fr 18px;
	}
`;

export const TableCellImage = styled.figure`
	grid-area: photo;
	position: relative;
	width: 100%;
	height: 0;
	margin: 0;
	padding: 0 0 70%;
	overflow: hidden;

	img {
		position: absolute;
		top: 50%;
		left: 0;
		width: 100%;
		min-height: 100%;
		object-fit: cover;
		transform: translateY(-50%);
	}
`;

export const ApartLink = styled(Link)`
	color: currentColor;
	text-decoration: none;

	&:hover {
		color: ${({ theme }) => theme.primaryColor};
	}
`;

export const TableCellText = styled.div`
	grid-area: ${({ $type }) => $type};
	font-size: ${({ $type }) => ($type === 'price' ? '18px' : '16px')};
	line-height: 1.3;
	color: ${({ $type, theme }) => ($type === 'price' ? theme.primaryColor : '#333')};

	@media (max-width: 600px) {
		font-size: ${({ $type }) => ($type === 'price' ? '18px' : $type === 'floor' ? '12px' : '14px')};
		color: ${({ $type, theme }) =>
			$type === 'price' ? theme.primaryColor : $type === 'floor' ? '#707070' : '#333'};
	}
`;

export const ChartWrapper = styled.div`
	grid-area: avgprice;
	margin: 60px 0 0;
`;

export const PriceStats = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1 1 100%;
	width: 100%;
	box-sizing: border-box;
`;

export const PriceStatsWrapper = styled.div`
	position: relative;
	display: grid;
	grid-column-gap: 35px;
	grid-template-columns: repeat(7, 1fr);
	align-items: end;
	height: 300px;
	flex-grow: 1;
	margin-bottom: 10px;
	padding: 0 10px 0 90px;
	direction: rtl;
	box-sizing: border-box;

	@media (max-width: 600px) {
		grid-column-gap: 10px;
		height: 150px;
	}
`;

export const PriceStatsBar = styled.div`
	min-width: 8px;
	height: ${({ $height }) => $height && `${$height}%`};
	background-color: ${({ theme, $next, $isCurrent }) =>
		$isCurrent ? theme.primaryColor : $next ? theme.grayColor : theme.lightGrayColor};

	&:hover {
		background-color: ${({ $isCurrent, theme }) => ($isCurrent ? theme.primaryColor : '#f3d0c9')};
	}
`;

export const PriceStatsTooltip = styled.div`
	max-width: 130px;
	text-align: center;
`;

export const PriceStatsDiff = styled.p`
	margin: 0;
	color: #b8b8b8;
`;

export const PriceAverage = styled.div`
	position: absolute;
	right: 0;
	bottom: ${({ $bottom }) => `${$bottom}%`};
	width: calc(100% - 80px);
	color: #333;
	font-size: 12px;
	direction: ltr;
	border-top: 1px dashed #3498db;
`;

export const PriceAverageValue = styled.div`
	position: absolute;
	top: 0;
	right: 100%;
	display: inline-block;
	padding: 2px 3px;
	transform: translateY(-50%);
	color: #707070;

	sup {
		font-size: 12px;
		color: ${({ theme }) => theme.primaryColor};
	}
`;

export const PriceAverageTooltip = styled.div`
	margin: 2px 0 14px;
	text-align: left;
	font-size: 14px;
	line-height: 1.33;
	color: #707070;

	span {
		font-size: 14px;
		color: ${({ theme }) => theme.primaryColor};
	}
`;

export const BottomRelatedRow = styled.div`
	grid-area: lastViewedAndSimilar;
	background: #fff;
	width: 100%;
`;

export const BottomWrapper = styled.div`
	display: flex;
	flex-direction: column;
	padding: 24px;
	gap: 24px;
	max-width: 1440px;
	margin: 0 auto;
`;

export const RelatedWrapper = styled.div`
	grid-area: related;
`;

export const ViewedWrapper = styled.div`
	grid-area: alsoviewed;
`;

export const RelatedTabs = styled.div`
	display: flex;
	width: 100%;
`;

export const RelatedTab = styled.button`
	display: flex;
	justify-content: center;
	align-items: baseline;
	flex-basis: 50%;
	background: transparent;
	cursor: pointer;
	border: none;
	border-bottom: ${({ theme, $isActive }) =>
		$isActive ? `2px solid ${theme.primaryColor}` : `2px solid ${theme.middleGrayColor}`};
	color: ${({ theme, $isActive }) => ($isActive ? theme.primaryBlackColor : theme.darkGrayColor)};
	max-width: 236px;
	height: 44px;

	span {
		white-space: nowrap;
		${({ theme }) => theme.typography.textBoldL};
		margin: 0;
		padding: 0;
	}

	@media (max-width: 600px) {
		height: 36px;
		max-width: 50%;
		span {
			${({ theme }) => theme.typography.textBoldS};
		}
	}
`;

export const RelatedTabTitle = styled.span`
	${({ theme }) => theme.typography.textBoldL};
	margin: 0;
	padding: 0;
`;

export const RelatedApartsScrolled = styled.div`
	width: 100%;
	overflow-x: auto;

	@media (max-width: 600px) {
		margin-left: -15px;
		margin-right: -15px;
	}
`;

export const RelatedApartsSlider = styled.div`
	width: 100%;

	.slick-slide {
		& > div {
			display: flex;
		}
	}
`;

export const RelatedAparts = styled.div`
	display: grid;
	grid-column-gap: 10px;
	grid-template-columns: repeat(5, minmax(250px, 280px));
`;

export const SellerType = styled.div`
	display: flex;
	flex-direction: row;
	background: ${({ theme }) => theme.lightGrayColor};
	border-radius: 4px;
	padding: 5px 9px;
	width: fit-content;
	margin-bottom: 24px;

	p {
		font-weight: 500;
		font-size: 14px;
		line-height: 135%;
		letter-spacing: 0.01em;
		color: ${({ theme }) => theme.primaryBlackColor};
		margin: 0;
	}
`;

export const SellerTypeImg = styled.svg`
	width: 16px;
	height: 16px;
	margin-right: 7px;
	fill: ${({ theme }) => theme.darkGrayColor};
`;

export const ResaleImg = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0;
	margin: 0;
	width: 90px;
	height: 90px;
	background-color: #ffffff;

	svg {
		width: 32px;
		height: 32px;
		fill: ${({ theme }) => theme.darkGrayColor};
	}
`;

export const SidebarTable = styled.div`
	display: flex;
	flex-direction: column;
	padding: 12px 12px 0;
	background: #fff;
	box-shadow: 0 0 8px rgba(0, 0, 0, 0.08);
	border-radius: 5px;

	@media (max-width: 600px) {
		padding: 12px 10px 0;
	}
`;

export const SidebarButtonsWrapper = styled.div`
	margin: 20px 0;
	display: grid;
	grid-gap: 15px;
	grid-template-columns: 1fr;
	justify-content: center;
`;

export const SidebarLineWrapper = styled.div`
	padding: 10px;
	border: 1px solid #e0e0e0;
	box-sizing: border-box;
	border-radius: 5px;

	&:not(:last-of-type) {
		margin-bottom: 15px;
	}
`;

export const SidebarIcon = styled.figure`
	grid-area: icon;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0;
	margin: 0;
	width: 32px;
	height: 32px;
	border: 1px solid #ebebeb;
	background-color: ${({ $withLogo }) => ($withLogo ? '#fff' : '#ebebeb')};
	border-radius: 5px;

	svg {
		width: 14px;
		height: 14px;
		fill: #c2c2c2;
	}

	img {
		width: 100%;
		height: auto;
		max-width: 28px;
		max-height: 28px;
	}
`;

export const SidebarSellerWrapper = styled.div`
	grid-area: seller;
`;

export const SidebarSeller = styled.div`
	margin-top: 6px;
	font-weight: 600;
	font-size: 14px;
	line-height: 1.43;
	color: #333;
`;

export const SidebarSellerType = styled.div`
	color: #c2c2c2;
	font-size: 12px;
	line-height: 1.33;
`;

export const SidebarPreviews = styled.div`
	display: flex;
	align-self: center;
	color: #c2c2c2;
	font-size: 14px;
	line-height: 1.43;

	svg {
		width: 24px;
		height: 20px;
		stroke: currentColor;
		fill: transparent;
		margin-right: 6px;
	}
`;

export const LogoWrapper = styled.div`
	display: flex;
	border-radius: 4px;
	background-color: ${({ theme }) => theme.lightGrayColor};
	padding: 8px 15px;
	justify-content: center;
	align-items: center;
	max-width: fit-content;
`;

export const LogoImg = styled.svg`
	width: 54px;
	height: 12px;
`;

export const LogoText = styled.p`
	${({ theme }) => theme.typography.textXS};
	margin: 0 0 0 8px;
	border-left: 1px solid ${({ theme }) => theme.primaryBlackColor};
	padding-left: 8px;
	white-space: nowrap;
`;
